"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWillNavigateToSearch = exports.useSearchBarContext = exports.SearchBarContextProvider = void 0;
var react_1 = __importStar(require("react"));
var defaultContext = {
    apiBaseUrl: '',
    buttonSize: undefined,
    cdnBaseUrl: '',
    customEventData: {},
    displayInputValue: '',
    geolocationState: '',
    globalInputValue: '',
    inputBgColor: undefined,
    noResultsQuery: undefined,
    onCloseModal: undefined,
    onFocus: undefined,
    onShowModalClick: undefined,
    onSuggestApiError: undefined,
    onSuggestionSelection: undefined,
    refSource: '',
    rounded: undefined,
    savedSearches: undefined,
    suggestionQuery: '',
    setDisplayInputValue: function () { },
    setSuggestionQuery: function () { },
    setNoResultsQuery: function () { },
    showButton: undefined,
    showModal: undefined,
    trackEvent: function () { }
};
var SearchBarContext = (0, react_1.createContext)(defaultContext);
function SearchBarContextProvider(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var globalInputValue = props.globalInputValue;
    var _b = (0, react_1.useState)(globalInputValue), suggestionQuery = _b[0], setSuggestionQuery = _b[1];
    var _c = (0, react_1.useState)(globalInputValue), displayInputValue = _c[0], setDisplayInputValue = _c[1];
    var _d = (0, react_1.useState)(), noResultsQuery = _d[0], setNoResultsQuery = _d[1];
    (0, react_1.useEffect)(function () {
        setSuggestionQuery(globalInputValue);
        setDisplayInputValue(globalInputValue);
    }, [globalInputValue]);
    var value = (0, react_1.useMemo)(function () { return (__assign(__assign({}, props), { displayInputValue: displayInputValue, noResultsQuery: noResultsQuery, suggestionQuery: suggestionQuery, setDisplayInputValue: setDisplayInputValue, setNoResultsQuery: setNoResultsQuery, setSuggestionQuery: setSuggestionQuery })); }, [displayInputValue, noResultsQuery, props, suggestionQuery]);
    return (react_1.default.createElement(SearchBarContext.Provider, { value: value }, children));
}
exports.SearchBarContextProvider = SearchBarContextProvider;
exports.default = SearchBarContext;
function useSearchBarContext() {
    return react_1.default.useContext(SearchBarContext);
}
exports.useSearchBarContext = useSearchBarContext;
function useWillNavigateToSearch() {
    return !Boolean(useSearchBarContext().onSuggestionSelection);
}
exports.useWillNavigateToSearch = useWillNavigateToSearch;
//# sourceMappingURL=SearchBarContext.js.map